module.exports = __webpack_public_path__ + "img/10.1d83bbf6.png";